export enum ClearingSystemCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AR = 'AR',
  AS = 'AS',
  ATBLZ = 'ATBLZ',
  AUBSB = 'AUBSB',
  AW = 'AW',
  AZ = 'AZ',
  BA = 'BA',
  BD = 'BD',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BRISP = 'BRISP',
  BS = 'BS',
  BT = 'BT',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CACPA = 'CACPA',
  CBHAC = 'CBHAC',
  CBHPA = 'CBHPA',
  CBPAC = 'CBPAC',
  CBPPA = 'CBPPA',
  CD = 'CD',
  CEAAC = 'CEAAC',
  CEAPA = 'CEAPA',
  CHBCC = 'CHBCC',
  CHSIC = 'CHSIC',
  CL = 'CL',
  CNAPS = 'CNAPS',
  CNCIP = 'CNCIP',
  CO = 'CO',
  CR = 'CR',
  CV = 'CV',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DEBLZ = 'DEBLZ',
  DO = 'DO',
  DZ = 'DZ',
  DZRAC = 'DZRAC',
  DZRPA = 'DZRPA',
  EC = 'EC',
  EE = 'EE',
  EGNCC = 'EGNCC',
  ESNCC = 'ESNCC',
  GBDSC = 'GBDSC',
  GE = 'GE',
  GH = 'GH',
  GN = 'GN',
  GRBIC = 'GRBIC',
  GT = 'GT',
  GY = 'GY',
  HKNCC = 'HKNCC',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IENCC = 'IENCC',
  IL = 'IL',
  INFSC = 'INFSC',
  IQ = 'IQ',
  IS = 'IS',
  ITNCC = 'ITNCC',
  JM = 'JM',
  JO = 'JO',
  JPZGN = 'JPZGN',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KM = 'KM',
  KRBOK = 'KRBOK',
  KW = 'KW',
  KZ = 'KZ',
  LB = 'LB',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MARAC = 'MARAC',
  MARPA = 'MARPA',
  MD = 'MD',
  ME = 'ME',
  MG = 'MG',
  MK = 'MK',
  MN = 'MN',
  MO = 'MO',
  MR = 'MR',
  MT = 'MT',
  MU = 'MU',
  MUPAC = 'MUPAC',
  MUPPA = 'MUPPA',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZBMO = 'MZBMO',
  NACSC = 'NACSC',
  NG = 'NG',
  NI = 'NI',
  NP = 'NP',
  NZNCC = 'NZNCC',
  NZRSA = 'NZRSA',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PLKNR = 'PLKNR',
  PS = 'PS',
  PTNCC = 'PTNCC',
  PY = 'PY',
  QA = 'QA',
  RO = 'RO',
  RS = 'RS',
  RSDAC = 'RSDAC',
  RSDPA = 'RSDPA',
  RSEAC = 'RSEAC',
  RSEPA = 'RSEPA',
  RUCBC = 'RUCBC',
  RW = 'RW',
  SA = 'SA',
  SC = 'SC',
  SD = 'SD',
  SESBA = 'SESBA',
  SGIBG = 'SGIBG',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  ST = 'ST',
  SV = 'SV',
  SZ = 'SZ',
  THCBC = 'THCBC',
  TJ = 'TJ',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TR = 'TR',
  TT = 'TT',
  TWNCC = 'TWNCC',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UGDAC = 'UGDAC',
  UGDPA = 'UGDPA',
  USABA = 'USABA',
  USPID = 'USPID',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VE = 'VE',
  VN = 'VN',
  XK = 'XK',
  ZANCC = 'ZANCC',
  ZM = 'ZM',
  ZWTSS = 'ZWTSS',
}
